module.exports = __webpack_public_path__ + "img/home_black_24dp.e23ac331.svg";